"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Showroom = exports.ShowroomState = void 0;
const core_1 = require("@babylonjs/core");
const watch_1 = require("./watch");
const gui_1 = require("@babylonjs/gui");
const watchStuds_1 = require("./watchStuds");
const showroom_camera_1 = require("@syntheticmagus/showroom-camera");
var ShowroomState;
(function (ShowroomState) {
    ShowroomState[ShowroomState["Overall"] = 0] = "Overall";
    ShowroomState[ShowroomState["Clasp"] = 1] = "Clasp";
    ShowroomState[ShowroomState["Face"] = 2] = "Face";
    ShowroomState[ShowroomState["Levitate"] = 3] = "Levitate";
    ShowroomState[ShowroomState["Configure"] = 4] = "Configure";
})(ShowroomState = exports.ShowroomState || (exports.ShowroomState = {}));
class Showroom {
    constructor(scene, watch, params) {
        this._scene = scene;
        this._state = ShowroomState.Overall;
        this._stateSetToConfigurationObservable = new core_1.Observable();
        this._watch = watch;
        this._camera = new showroom_camera_1.ShowroomCamera(this._scene);
        this._camera.fov = 0.5;
        this._camera.minZ = 0.01;
        this._camera.maxZ = 100;
        this._overallState = {
            matchmoveTarget: this._watch.cameraParentOverall,
            focusDepth: this._watch.cameraParentOverall.position.length()
        };
        this._claspState = {
            matchmoveTarget: this._watch.cameraParentClasp,
            focusDepth: this._watch.cameraParentClasp.position.length()
        };
        this._faceState = {
            matchmoveTarget: this._watch.cameraParentFace,
            focusDepth: this._watch.cameraParentFace.position.length()
        };
        this._levitateState = {
            matchmoveTarget: this._watch.cameraParentLevitate,
            focusDepth: this._watch.cameraParentLevitate.position.length()
        };
        this._configureState = {
            startingPosition: this._watch.cameraParentOverall.absolutePosition.clone(),
            target: this._watch.cameraParentOverall.parent.absolutePosition.clone(),
            lowerRadiusLimit: 3,
            upperRadiusLimit: 15
        };
        this._watch.setState(watch_1.WatchState.Overall);
        this._camera.setToMatchmoveState(this._overallState);
        this._state = ShowroomState.Overall;
        const configurationPromise = new Promise((resolve) => {
            this._stateSetToConfigurationObservable.addOnce(() => {
                resolve();
            });
        });
        fetch(params.assetUrlRoot + "/" + params.assetUrlWatchStuds);
        const studsPromise = configurationPromise.then(() => {
            return watchStuds_1.WatchStuds.CreateAsync(scene, params);
        });
        studsPromise.then((studs) => {
            studs.Mesh.setEnabled(false);
            this._studs = studs;
            watch.attachToBodyBone(studs.Mesh);
        });
        fetch(params.assetUrlRoot + "/" + params.assetUrlWatchMaterials);
        const materialsPromise = configurationPromise.then(() => {
            return core_1.SceneLoader.ImportMeshAsync("", params.assetUrlRoot, params.assetUrlWatchMaterials, scene).then((result) => {
                result.meshes[0].setEnabled(false);
                return result;
            });
        });
        materialsPromise.then((result) => {
            // Force compilation for band materials to prevent flashing on configuration.
            const chassis = this._scene.getMeshByName("chassis");
            const material = this._scene.getMaterialByName("band_1");
            material.forceCompilationAsync(chassis);
        });
        this._configurationOptionsLoaded = false;
        this.configurationOptionsLoadedObservable = new core_1.Observable();
        Promise.all([studsPromise, materialsPromise]).then(() => {
            this._configurationOptionsLoaded = true;
            this.configurationOptionsLoadedObservable.notifyObservers(this);
        });
        this.onHotspotUpdatedObservable = new core_1.Observable();
        this._watch.onHotspotsUpdatedObservable.add(() => {
            this.onHotspotUpdatedObservable.notifyObservers({
                hotspotId: 0,
                visible: this._watch.hotspot0State.isVisible,
                x: this._watch.hotspot0State.position.x,
                y: this._watch.hotspot0State.position.y
            });
            this.onHotspotUpdatedObservable.notifyObservers({
                hotspotId: 1,
                visible: this._watch.hotspot1State.isVisible,
                x: this._watch.hotspot1State.position.x,
                y: this._watch.hotspot1State.position.y
            });
            this.onHotspotUpdatedObservable.notifyObservers({
                hotspotId: 2,
                visible: this._watch.hotspot2State.isVisible,
                x: this._watch.hotspot2State.position.x,
                y: this._watch.hotspot2State.position.y
            });
        });
    }
    get scene() {
        return this._scene;
    }
    get state() {
        return this._state;
    }
    set state(state) {
        if (this._state === state) {
            return;
        }
        this._state = state;
        switch (this._state) {
            case ShowroomState.Overall:
                this._watch.setState(watch_1.WatchState.Overall);
                this._camera.animateToMatchmoveState(this._overallState);
                break;
            case ShowroomState.Clasp:
                this._watch.setState(watch_1.WatchState.Clasp);
                this._camera.animateToMatchmoveState(this._claspState);
                break;
            case ShowroomState.Face:
                this._watch.setState(watch_1.WatchState.Face);
                this._camera.animateToMatchmoveState(this._faceState);
                break;
            case ShowroomState.Levitate:
                this._watch.setState(watch_1.WatchState.Levitate);
                this._camera.animateToMatchmoveState(this._levitateState);
                break;
            case ShowroomState.Configure:
                this._watch.setState(watch_1.WatchState.Configure);
                this._camera.animateToArcRotateState(this._configureState).then(() => {
                    return core_1.Tools.DelayAsync(300);
                }).then(() => {
                    this._stateSetToConfigurationObservable.notifyObservers();
                });
                break;
        }
    }
    set showStuds(visibility) {
        var _a, _b;
        (_b = (_a = this._studs) === null || _a === void 0 ? void 0 : _a.Mesh) === null || _b === void 0 ? void 0 : _b.setEnabled(visibility);
    }
    get configurationOptionsLoaded() {
        return this._configurationOptionsLoaded;
    }
    setZoomPercent(zoomPercent) {
        this._camera.arcRotateZoomPercent = zoomPercent;
    }
    disableMouseWheel() {
        this._camera.enableMouseWheel = false;
    }
    static CreateAsync(engine, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const scene = new core_1.Scene(engine);
            scene.clearColor = core_1.Color3.White().toColor4();
            scene.skipFrustumClipping = true;
            const environmentTexture = core_1.CubeTexture.CreateFromPrefilteredData(params.assetUrlRoot + params.assetUrlEnvironmentTexture, scene);
            scene.environmentTexture = environmentTexture;
            const watch = yield watch_1.Watch.createAsync(scene, params);
            return new Showroom(scene, watch, params);
        });
    }
    render() {
        this._scene.render();
    }
    setMeshMaterialByName(meshName, materialName) {
        const mesh = this._scene.getMeshByName(meshName);
        const material = this._scene.getMaterialByName(materialName);
        if (mesh && material) {
            mesh.material = material;
            return true;
        }
        return false;
    }
    createDebugtUI() {
        const hotspotTexture = gui_1.AdvancedDynamicTexture.CreateFullscreenUI("hotspotTexture", true, this._scene);
        const hotspot0 = new gui_1.Rectangle("hotspot0");
        hotspot0.verticalAlignment = gui_1.Rectangle.VERTICAL_ALIGNMENT_TOP;
        hotspot0.horizontalAlignment = gui_1.Rectangle.HORIZONTAL_ALIGNMENT_LEFT;
        hotspot0.color = "red";
        hotspot0.widthInPixels = 10;
        hotspot0.heightInPixels = 10;
        hotspotTexture.addControl(hotspot0);
        const hotspot1 = new gui_1.Rectangle("hotspot1");
        hotspot1.verticalAlignment = gui_1.Rectangle.VERTICAL_ALIGNMENT_TOP;
        hotspot1.horizontalAlignment = gui_1.Rectangle.HORIZONTAL_ALIGNMENT_LEFT;
        hotspot1.color = "blue";
        hotspot1.widthInPixels = 10;
        hotspot1.heightInPixels = 10;
        hotspotTexture.addControl(hotspot1);
        const hotspot2 = new gui_1.Rectangle("hotspot2");
        hotspot2.verticalAlignment = gui_1.Rectangle.VERTICAL_ALIGNMENT_TOP;
        hotspot2.horizontalAlignment = gui_1.Rectangle.HORIZONTAL_ALIGNMENT_LEFT;
        hotspot2.color = "green";
        hotspot2.widthInPixels = 10;
        hotspot2.heightInPixels = 10;
        hotspotTexture.addControl(hotspot2);
        let showHotspots = false;
        this._scene.onBeforeRenderObservable.add(() => {
            hotspot0.isVisible = showHotspots && this._watch.hotspot0State.isVisible;
            hotspot0.leftInPixels = this._watch.hotspot0State.position.x;
            hotspot0.topInPixels = this._watch.hotspot0State.position.y;
            hotspot1.isVisible = showHotspots && this._watch.hotspot1State.isVisible;
            hotspot1.leftInPixels = this._watch.hotspot1State.position.x;
            hotspot1.topInPixels = this._watch.hotspot1State.position.y;
            hotspot2.isVisible = showHotspots && this._watch.hotspot2State.isVisible;
            hotspot2.leftInPixels = this._watch.hotspot2State.position.x;
            hotspot2.topInPixels = this._watch.hotspot2State.position.y;
        });
        const guiTexture = gui_1.AdvancedDynamicTexture.CreateFullscreenUI("guiTexture", true, this._scene);
        guiTexture.idealHeight = 700;
        guiTexture.idealWidth = guiTexture.idealHeight * 16 / 9;
        const stateGroup = new gui_1.RadioGroup("State");
        stateGroup.addRadio("Overall", () => { this.state = ShowroomState.Overall; }, true);
        stateGroup.addRadio("Clasp", () => { this.state = ShowroomState.Clasp; }, false);
        stateGroup.addRadio("Face", () => { this.state = ShowroomState.Face; }, false);
        stateGroup.addRadio("Levitate", () => { this.state = ShowroomState.Levitate; }, false);
        stateGroup.addRadio("Configure", () => { this.state = ShowroomState.Configure; }, false);
        const additionsGroup = new gui_1.CheckboxGroup("Additions");
        additionsGroup.addCheckbox("Studs", (checked) => { this.showStuds = checked; }, false);
        const bandsGroup = new gui_1.RadioGroup("Bands");
        bandsGroup.addRadio("band_0", () => { this.setMeshMaterialByName("chassis", "band_0"); }, true);
        bandsGroup.addRadio("band_1", () => { this.setMeshMaterialByName("chassis", "band_1"); }, false);
        bandsGroup.addRadio("band_2", () => { this.setMeshMaterialByName("chassis", "band_2"); }, false);
        bandsGroup.addRadio("band_3", () => { this.setMeshMaterialByName("chassis", "band_3"); }, false);
        bandsGroup.addRadio("band_4", () => { this.setMeshMaterialByName("chassis", "band_4"); }, false);
        const hotspotsGroup = new gui_1.CheckboxGroup("Hotspots");
        hotspotsGroup.addCheckbox("Show", (checked) => { showHotspots = checked; }, false);
        const leftSelectionPanel = new gui_1.SelectionPanel("leftSelectionPanel", [stateGroup, additionsGroup, bandsGroup, hotspotsGroup]);
        leftSelectionPanel.verticalAlignment = gui_1.SelectionPanel.VERTICAL_ALIGNMENT_TOP;
        leftSelectionPanel.horizontalAlignment = gui_1.SelectionPanel.HORIZONTAL_ALIGNMENT_LEFT;
        leftSelectionPanel.widthInPixels = 200;
        leftSelectionPanel.color = "#000000AA";
        leftSelectionPanel.background = "#DDDDDDAA";
        leftSelectionPanel.barColor = "#000000AA";
        guiTexture.addControl(leftSelectionPanel);
        const glassGroup = new gui_1.RadioGroup("Glass");
        glassGroup.addRadio("glass_0", () => { this.setMeshMaterialByName("glass", "glass_0"); }, true);
        glassGroup.addRadio("glass_1", () => { this.setMeshMaterialByName("glass", "glass_1"); }, false);
        glassGroup.addRadio("glass_2", () => { this.setMeshMaterialByName("glass", "glass_2"); }, false);
        glassGroup.addRadio("glass_3", () => { this.setMeshMaterialByName("glass", "glass_3"); }, false);
        glassGroup.addRadio("glass_4", () => { this.setMeshMaterialByName("glass", "glass_4"); }, false);
        const gemGroup = new gui_1.RadioGroup("Gem");
        gemGroup.addRadio("diamond_face", () => { this.setMeshMaterialByName("diamond", "diamond_face"); }, true);
        gemGroup.addRadio("sapphire_face", () => { this.setMeshMaterialByName("diamond", "sapphire_face"); }, false);
        gemGroup.addRadio("ruby_face", () => { this.setMeshMaterialByName("diamond", "ruby_face"); }, false);
        gemGroup.addRadio("emerald_face", () => { this.setMeshMaterialByName("diamond", "emerald_face"); }, false);
        const settingGroup = new gui_1.RadioGroup("Setting");
        settingGroup.addRadio("setting_gold", () => { this.setMeshMaterialByName("setting", "setting_gold"); }, true);
        settingGroup.addRadio("setting_silver", () => { this.setMeshMaterialByName("setting", "setting_silver"); }, false);
        settingGroup.addRadio("setting_copper", () => { this.setMeshMaterialByName("setting", "setting_copper"); }, false);
        settingGroup.addRadio("setting_iron", () => { this.setMeshMaterialByName("setting", "setting_iron"); }, false);
        const rightSelectionPanel = new gui_1.SelectionPanel("rightSelectionPanel", [glassGroup, gemGroup, settingGroup]);
        rightSelectionPanel.verticalAlignment = gui_1.SelectionPanel.VERTICAL_ALIGNMENT_TOP;
        rightSelectionPanel.horizontalAlignment = gui_1.SelectionPanel.HORIZONTAL_ALIGNMENT_RIGHT;
        rightSelectionPanel.widthInPixels = 200;
        rightSelectionPanel.color = "#000000AA";
        rightSelectionPanel.background = "#DDDDDDAA";
        rightSelectionPanel.barColor = "#000000AA";
        guiTexture.addControl(rightSelectionPanel);
    }
}
exports.Showroom = Showroom;
